import { getListagemEmpresas } from "@/services/api/rotas";
import { useQuery } from "@tanstack/react-query";
import { useWebgate } from "@xvia/webgate-connect";
export const useGetListagemEmpresas = () => {
    const { accessToken } = useWebgate();
    return useQuery({
        queryKey: ["listagem-empresas"],
        queryFn: () => getListagemEmpresas(accessToken),
        enabled: true,
        refetchOnWindowFocus: true,
    });
};
